import React from "react";
import "./doubleCircle.css";

const CircularProgressBar = ({ percentage, color, bgColor }) => {
  return (
    <div className="circular-progress">
      {/* Outer Progress Circle */}
      <div
        className="outer-circle"
        style={{
          "--percentage": percentage,
          background: `conic-gradient(${color} calc(var(--percentage) * 3.6deg), #e0e0e0 0deg)`,
        }}
      ></div>

      {/* Middle White Circle */}
      <div className="middle-circle" style={{ backgroundColor: bgColor }}></div>

      {/* Inner Gray Circle with Percentage */}
      <div className="inner-circle">
        <span className="percentage-text">{percentage}%</span>
      </div>
    </div>
  );
};

const CircularProgressGrid = ({ color, value, bgColor }) => {
  return (
    <div className="progress-grid">
      <CircularProgressBar percentage={value} color={color} bgColor={bgColor} />
    </div>
  );
};

export default CircularProgressGrid;
